import { FrameworkClasses } from '../framework/frameworkClasses';
import { FrameworkClassPartType } from '../framework/framework-enums';
import { FrameworkClassType } from '../framework/framework-types';

let frameworkClassNames: ReadonlySet<string> | null = null;
let frameworkMechanismClassNames: ReadonlySet<string> | null = null;
let frameworkSensorClassNames: ReadonlySet<string> | null = null;

/** Framework constructor class names for all registered device/part types. */
export function getFrameworkClassNames(): ReadonlySet<string> {
  if (!frameworkClassNames) {
    frameworkClassNames = new Set(FrameworkClasses.map((frameworkClass) => frameworkClass.name));
  }
  return frameworkClassNames;
}

/** Framework constructor class names for sensor part types. */
export function getFrameworkSensorClassNames(): ReadonlySet<string> {
  if (!frameworkSensorClassNames) {
    frameworkSensorClassNames = new Set(
      FrameworkClasses.filter((frameworkClass) => frameworkClass.partType === FrameworkClassPartType.Sensors).map(
        (frameworkClass) => frameworkClass.name
      )
    );
  }
  return frameworkSensorClassNames;
}

/** Allowed constructor classes when anchoring on a framework action target variable. */
export function getFrameworkActionTargetAllowedClassNames(frameworkClassName?: string | null): ReadonlySet<string> | undefined {
  return frameworkClassName ? new Set([frameworkClassName]) : undefined;
}

/** Mechanism classes shown in mechanism hardware UI (excludes DriveBase). */
export function getFrameworkMechanismClassNames(): ReadonlySet<string> {
  if (!frameworkMechanismClassNames) {
    frameworkMechanismClassNames = new Set(
      FrameworkClasses.filter((frameworkClass) => frameworkClass.type === FrameworkClassType.Mechanism && frameworkClass.uiPanel !== 'DriveBase').map(
        (frameworkClass) => frameworkClass.name
      )
    );
  }
  return frameworkMechanismClassNames;
}
